<ion-header>
  <ion-row class="ion-align-items-center">
    <div class="column">
      <div class="back" (click)="back()">
        <img src="assets/icon/back.svg" alt="" />
      </div>
      <div class="logo">{{'rental.not_completed_rentals' | translate}}</div>
      @if (sequences?.length) {
        <div class="header-actions">
          <button class="chip-action" [disabled]="sending" (click)="showAllOnTablet()">
            <span class="chip-pulse"></span>
            <span class="chip-label">
              {{ sending ? ('rental.sending' | translate) : ('rental.show_all_on_tablet' | translate) }}
            </span>
          </button>
        </div>
      }
    </div>
  </ion-row>
</ion-header>
<ion-content [forceOverscroll]="false">
  <div class="wrapper">
    @for (sequence of sequences; track sequence.createdAt) {
      <div class="sequence-card">
        <div class="sequence-header">
          <div class="sequence-left">
            <div class="sequence-title">{{ sequence.createdAt | date:'short' }}</div>
            <div class="sequence-sub">
              Baskets: <strong>{{ sequence.baskets?.length || 0 }}</strong>
              • Created: <span>{{ sequence.createdAt ? (sequence.createdAt | date:'short') : '-' }}</span>
            </div>
          </div>
          <div class="sequence-actions">
            <div class="sequence-status" [ngClass]="{ 'suspicious': sequence.suspicious, 'ok': !sequence.suspicious }">
              {{ (sequence.suspicious ? 'rental.suspicious' : 'rental.normal') | translate }}
            </div>
          </div>
        </div>
        <div class="baskets-list">
          @for (basket of sequence.baskets; track basket._id) {
            <div class="basket-card">
              <div class="basket-card__header">
                <div>
                  <div class="basket-title">Order #{{ basket.orderNumber }}</div>
                  <div class="basket-meta">
                    {{ basket.date | date:'short' }}
                  </div>
                </div>
                <div class="basket-deposit">
                  Total: <span class="value">{{ money(basket.total) }}</span><br/>
                  Deposit: <span class="value">{{ money(basket.rentalDeposit) }}</span>
                  @if ((+basket.rentalDeposit) > 0) {
                    <div class="deposit-flag">
                      @if (isDepositReturned(basket)) {
                        <span class="returned">{{ 'rental.returned' | translate }}</span>
                      }
                      @if (!isDepositReturned(basket)) {
                        <span class="not-returned">{{ 'rental.not_returned' | translate }}</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="basket-body">
                <div class="section products">
                  <div class="section-title">{{ 'rental.items' | translate }}</div>
                  @for (p of basket.products; track p.productId) {
                    <div class="product-item">
                      <div class="prod-left">
                        <div class="prod-name">{{ p.productName || p.aiId || p.productId }}</div>
                        <div class="prod-desc">{{ p.description }}</div>
                        <div class="prod-tags">
                          @if (p.isRentable) {
                            <span class="tag">Rentable</span>
                          }
                          <span class="tag-price">{{ 'rental.deposit' | translate }}: {{ money(p.rentalDeposit) }}</span>
                        </div>
                      </div>
                      <div class="prod-qty"><span class="tag-price">{{ money(p.price) }}</span>x{{ p.quantity || 1 }}</div>
                    </div>
                  }
                  @if (!basket.products || basket.products.length === 0) {
                    <div class="empty">{{ 'rental.no_items' | translate }}</div>
                  }
                </div>
                <div class="section payment">
                  <div class="section-title">{{ 'rental.payment' | translate }}</div>
                  <!--              -->
                  <!--              <div class="payment-status">-->
                  <!--                <span [ngClass]="paymentClass(basket.paymentInfo?.status)">{{ basket.paymentInfo?.status || 'Unknown' }}</span>-->
                  <!--                • Paid: {{ money(basket.paymentInfo?.paidAmount) }} -->
                <!--              </div>-->
                @if (basket.paymentInfo?.payments?.pos?.length) {
                  <div class="payment-list">
                    @for (p of basket.paymentInfo.payments.pos; track $index) {
                      <div class="payment-row">
                        POS • {{ p.status }} • {{ 'rental.receipt' | translate }}: {{ p.reservation?.receiptNo || '-' }} • {{ p.createdAt ? (p.createdAt | date:'short') : '-' }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="section customer">
                <div class="section-title">{{ 'rental.customer' | translate }}</div>
                <div>Phone: @if (basket.customerPhoneNumber) {
                  <span>{{ basket.customerPhoneNumber }}</span>
                  }@if (!basket.customerPhoneNumber) {
                  <span class="empty">No phone</span>
                }</div>
                @if (basket.customerCardUID) {
                  <div>Card UID: {{ basket.customerCardUID }}</div>
                }
              </div>
              <div class="basket-actions">
                @if (isLastBasket(basket, sequence)) {
                  <button class="btn outline"
                    [disabled]="sendingSingle[getLastBasketId(sequence)]"
                    (click)="showBasketOnTablet(basket._id)">
                    {{
                    sendingSingle[getLastBasketId(sequence)]
                    ? ('rental.sending' | translate)
                    : ('rental.show_on_tablet' | translate)
                    }}
                  </button>
                }
                @if (canMarkReturned(basket) && isLastBasket(basket, sequence)) {
                  <button class="btn"
                    (click)="completeRentalReturnAll(basket)">
                    {{ 'rental.button_mark' | translate }}
                  </button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
</ion-content>
